import {rqCreateRequest, rqCreateSearchRequest} from './rqHttpsUtils';
import {
  RQ_CREATE_DIGI_DOCUMENT_SIGNER_CONFIGURATION_API,
  RQ_GET_DIGI_DOCUMENT_SIGNER_CONFIGURATION_ALL_API,
  RQ_GET_DIGI_DOCUMENT_SIGNER_CONFIGURATION_FIND_BY_ID_API, RQ_SEARCH_DIGI_DOCUMENT_SIGNER_CONFIGURATION_API,
  RQ_UPDATE_DIGI_DOCUMENT_SIGNER_CONFIGURATION_API,
} from './constants';
import {useQuery} from '@tanstack/react-query';

export const RQPostCreateDigiDocumentSignerConfiguration = async ({
  digiDocumentSignerConfiguration,
  token,
  signal,
}) => {
  return rqCreateRequest(
    RQ_CREATE_DIGI_DOCUMENT_SIGNER_CONFIGURATION_API,
    JSON.stringify({...digiDocumentSignerConfiguration}),
    token,
    null,
    signal,
  );
};

export const RQSearchDigiDocumentSignerConfiguration= payload => {
  return useQuery(
    ['rq_get_search_event_approval_amount_config', payload],
    async ({queryKey, signal}) => {
      const {token, filter} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_SEARCH_DIGI_DOCUMENT_SIGNER_CONFIGURATION_API,
        null,
        token,
        null,
        signal,
        filter,
      );
    },
  );
};

export const RQGetAllDigiDocumentSignerConfiguration = payload => {
  return useQuery(
    ['rq_get_all_DIGI_DOCUMENT_SIGNER_CONFIGURATION', payload],
    async ({queryKey, signal}) => {
      const {token} = queryKey[1];
      return rqCreateRequest(
        RQ_GET_DIGI_DOCUMENT_SIGNER_CONFIGURATION_ALL_API,
        null,
        token,
        null,
        signal,
      );
    },
  );
};

export const RQPutDigiDocumentSignerConfigurationUpdateAllField = async ({
  digiDocumentSignerConfiguration,
  token,
  signal,
}) => {
  return rqCreateRequest(
    RQ_UPDATE_DIGI_DOCUMENT_SIGNER_CONFIGURATION_API,
    JSON.stringify({...digiDocumentSignerConfiguration}),
    token,
    null,
    signal,
  );
};

export const RQGetDigiDocumentSignerConfigurationByIdData = payload => {
  return useQuery(
    ['rq_get_DIGI_DOCUMENT_SIGNER_CONFIGURATION_by_id_data', payload],
    async ({queryKey, signal}) => {
      const {id, token} = queryKey[1];

      return rqCreateRequest(
        RQ_GET_DIGI_DOCUMENT_SIGNER_CONFIGURATION_FIND_BY_ID_API,
        null,
        token,
        {id:id},
        signal,
      );
    },
    {
      cacheTime: 0,
    },
  );
};
